import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { CalendarView } from '../../../types/calendar';
import { formatDate } from '../../../utils/date';

interface CalendarHeaderProps {
  currentDate: Date;
  view: CalendarView;
  onViewChange: (view: CalendarView) => void;
  onPrevious: () => void;
  onNext: () => void;
}

export default function CalendarHeader({
  currentDate,
  view,
  onViewChange,
  onPrevious,
  onNext
}: CalendarHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-4">
        <h2 className="text-xl font-semibold text-gray-900">
          {formatDate(currentDate, view)}
        </h2>
        <div className="flex space-x-2">
          <button
            onClick={onPrevious}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ChevronLeft className="h-5 w-5 text-gray-600" />
          </button>
          <button
            onClick={onNext}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ChevronRight className="h-5 w-5 text-gray-600" />
          </button>
        </div>
      </div>

      <div className="flex space-x-2">
        {([
          { id: 'month', label: 'Mês' },
          { id: 'week', label: 'Semana' },
          { id: 'day', label: 'Dia' }
        ] as { id: CalendarView; label: string }[]).map((viewOption) => (
          <button
            key={viewOption.id}
            onClick={() => onViewChange(viewOption.id)}
            className={`px-4 py-2 rounded-lg transition-colors ${
              view === viewOption.id
                ? 'bg-indigo-600 text-white'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            {viewOption.label}
          </button>
        ))}
      </div>
    </div>
  );
}